import { useState, useEffect } from "react";
import useWebSocket from "react-use-websocket";

export const useWebsocketFetchOrders = ({ onSuccessOrders }) => {
  const [socketUrl, setSocketUrl] = useState(null);
  const [statusOrders, setStatus] = useState("off");
  const [dataOrders, setData] = useState([]);

  const { sendJsonMessage, lastJsonMessage } = useWebSocket(socketUrl, {
    onOpen: () => {
      // console.log(`Connected to App WS orders`);
      setStatus("on");
      setData([]);
    },
    onClose: () => {
      // console.log("close orders");
      if (
        (dataOrders?.length === 0 && statusOrders === "fetching") ||
        (dataOrders?.length === 1 &&
          (dataOrders[0]?.MessageResponse === "Nenhum registro localizado." ||
          dataOrders[0]?.MessageResponse === "Falha em validação de filtros!"))
      ) {
        setStatus("empty");
      }
      
      if (dataOrders.length !== 0) {
        onSuccessOrders(dataOrders);
        setStatus("off");
      }
      setData([]);
    },
    onError: () => {
      // console.log('erro');
      setStatus("error");
    },
    shouldReconnect: () => true,
    reconnectInterval: 2000,
  });

  const handleFetchDataOrders = (data) => {
    // console.log("data request orders", data);
    setStatus("fetching");
    sendJsonMessage(data);
  };

  const handleFetchUrlOrders = (url) => {
    setSocketUrl(url);
  };

  const onMessageReceive = (response) => {
    // console.log("response orders-->", response);
    if (
      !response?.Result ||
      response?.message === "Forbidden" ||
      response?.Result[0]?.MessageResponse === "Nenhum registro localizado." ||
      response?.Result[0]?.MessageResponse === "Falha em validação de filtros!"
    ) {
      setStatus("empty");
      return;
    }
    setData([...dataOrders, ...response?.Result]);
  };

  useEffect(() => {
    if (lastJsonMessage) {
      onMessageReceive(lastJsonMessage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastJsonMessage]);

  return {
    handleFetchDataOrders,
    handleFetchUrlOrders,
    dataOrders,
    statusOrders,
  };
};
